export default __webpack_public_path__ + "80486021a4f6117ecc4d3b31dd5f026d.png";